<template>
  <transition name="cube-toast-fade" @before-leave="onClose" @after-leave="$emit('destroy')">
    <cube-popup
      :id="id"
      type="toast"
      :z-index="zIndex"
      :mask="mask"
      class="cube-toast-creator"
      v-model:visible="isVisible"
      @mask-click="maskClick"
      >
      <i v-if="!isLoading && iconClass.length" class="iconfont" :class="iconClass"></i>
      <cube-loading v-if="isLoading"></cube-loading>
      <div v-show="txt" class="cube-toast-tip" v-html="txt"></div>
    </cube-popup>
  </transition>
</template>
<script>
import CubeLoading from '../Loading'
import CubePopup from '../Popup'
import { defineComponent, computed, ref, nextTick } from '@vue/runtime-core'

export default defineComponent({
  name:'cube-toast',
  components: {
    CubePopup,
    CubeLoading
  },
  props:{
    id: { type: String, default: '' },
    type: {
      type: String,
      default: 'loading'
    },
    icon: {
      type: String,
      default: ''
    },
    mask: {
      type: Boolean,
      default: false
    },
    txt: {
      type: String,
      default: ''
    },
    time: {
      type: Number,
      default: 1500
    },
    // By default, Toast has the bigest z-index among popoup-based components.
    zIndex: {
      type: Number,
      default: 900
    },
    maskClosable: {
      type: Boolean,
      default: false
    },
    onClose:{
      type: Function,
      required: false
    },
  },
  emits:['timeout','destroy'],
  setup(props, { emit }){
    let isVisible = ref(false)
    let timer = null
    const iconClass = computed(() => {
      const ticonClass = []
      if (props.icon) {
        ticonClass.push(props.icon)
      }
      const classMap = {
        correct: 'icon-correct',
        error: 'icon-close',
        warn: 'icon-warn'
      }
      const icon = classMap[props.type]
      if (icon) {
        ticonClass.push(icon)
      }
      return ticonClass
    })
    const  isLoading = computed(()=> {
      return props.type === 'loading'
    })
    const cusHide = () => {
      clearTimer()
      isVisible.value = false
    }
    const clearTimer = () => {
      timer && clearTimeout(timer)
      timer = null
    }
    const cusShow = ()=>{
      isVisible.value = true
      clearTimer()
      nextTick(() => {
        if (props.time !== 0) {
          timer = setTimeout(() => {
            cusHide()
            emit('timeout')
          }, props.time)
        }
      })
    }
    const maskClick = ()=>{
      props.maskClosable && cusHide()
    }
    return {
      isVisible,
      iconClass,
      isLoading,
      show: cusShow,
      hide: cusHide ,
      maskClick
    }
  }
})
</script>